// Internal
import { gql } from "lib/apolloClient";

// Relative
import { creditsFragment } from "./DefineSubjectCreditsFragments";

export const getCreditsDetailsQuery = gql`
  query getCreditsDetailsQuery(
    $id: ID!
    $curriculumNodeInterfaceType: ENTITY_TYPE_ENUM!
    $creditsFilter: GradeSubjectTermCreditMapFilters
  ) {
    node(id: $id, type: $curriculumNodeInterfaceType) {
      id
      ... on IbPypCurriculumProgram {
        id
        credits(filters: $creditsFilter) {
          ...creditsItem
        }
      }
      ... on IbMypCurriculumProgram {
        id
        credits(filters: $creditsFilter) {
          ...creditsItem
        }
      }
      ... on IbDpCurriculumProgram {
        id
        credits(filters: $creditsFilter) {
          ...creditsItem
        }
      }
      ... on UBDCurriculumProgram {
        id
        credits(filters: $creditsFilter) {
          ...creditsItem
        }
      }
    }
  }
  ${creditsFragment.basicCreditsDetails}
`;

export const getAcademicYearTermsDetailsForCreditsSetupQuery = gql`
  query getAcademicYearTermsDetailsForCreditsSetupQuery(
    $id: ID!
    $termFilters: TermFilters
  ) {
    node(id: $id, type: ACADEMIC_YEAR) {
      id
      ... on AcademicYear {
        id
        terms(filters: $termFilters) {
          id
          label
          type
          lockingStatus
          associatedAcademicTermEntities {
            id
            academicTerm {
              id
              type
            }
          }
        }
      }
    }
  }
`;
